import { atom } from 'jotai'

export { adminJudgesRemoteAtom as adminJudgesAtom } from './remoteAtoms'
export const adminJudgeFilterAtom = atom('')
